import { List } from 'immutable';
import { composeInitialState } from '@opengov/compose-app';
import { EmptyListOf } from '@opengov/compose-app/immutable';

import { composeStateMachine } from '../module';
import { IUser } from '../types';

import { User } from './records';

export const userInitialState = composeInitialState({
  users: EmptyListOf(User)
});

export const userState = composeStateMachine('users', userInitialState, (compose) => ({
  loadingUsersSuccess: compose.action((state, payload: IUser[]) => state.set('users', List(payload.map(User))))
}));

export const {
  actions: userActions,
  actionCreators: userActionCreators,
  reducer: userReducer,
  selector: userSelector
} = userState;
